export const getCurrentHost = () => {
  if (window.location.host.includes("adesk")) {
    return "crewmama"
  } else if (
    window.location.host.includes("crewmama") ||
    window.location.host.includes("localhost")
  ) {
    return "crewmama"
  }
  return window.location.host
}
